"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledCheckbox = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));

var _templateObject;

/* istanbul ignore next */
var StyledCheckbox = (0, _styledComponents.default)(_Checkbox.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  &.Mui-disabled {\n    pointer-events: unset;\n    cursor: not-allowed;\n  }\n"])));
exports.StyledCheckbox = StyledCheckbox;

var SACDCheckBox = function SACDCheckBox(props) {
  return /*#__PURE__*/_react.default.createElement(StyledCheckbox, Object.assign({
    disableRipple: true,
    color: "secondary"
  }, props));
};

var _default = SACDCheckBox;
exports.default = _default;